import { Button, Icon, Label } from '@mairistem/composants';
import React from 'react';
import { version as frontendVersion } from '../../../package.json';
import { CODE_CLIENT_SESSION } from '../../constants/Login';
import type { Role } from '../../interfaces/auth';
import type Collectivite from '../../interfaces/collectivite';
import './AppHeader.css';

interface AppHeaderProps {
	userRole: Role;
	backendVersion: string;
	collectivites: Collectivite[];
	onLogout: () => void;
	onChangeClient?: () => void;
}

const AppHeader = ({
	userRole,
	backendVersion,
	collectivites,
	onLogout,
	onChangeClient,
}: AppHeaderProps) => {
	const codeClient = sessionStorage.getItem(CODE_CLIENT_SESSION);
	const collectiviteSF = collectivites.find(
		(c) => c.codeClientSF?.trim() === codeClient?.trim(),
	);
	const denomination = collectiviteSF?.libelle ?? collectivites[0]?.libelle;

	return (
		<div className="app-header">
			<div className="app-header-content">
				<div className="app-header-logo">
					{/* SVG inline */}
					<svg
						version="1.1"
						id="Calque_1"
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						viewBox="0 0 1000 300.6"
						xmlSpace="preserve"
						className="app-logo-img"
					>
						<title>Logo de l'application</title>
						<style type="text/css">{'.st0{fill:#FFFFFF;}'}</style>
						<g>
							<path
								className="st0"
								d="M23.8,51.8c-2.7-3.1-5.8-4.6-9.5-4.6H0v25.6h27.8V63C27.8,58.7,26.5,54.9,23.8,51.8z M23.8,88.1c-2.7-3.1-5.8-4.6-9.5-4.6H0V207h27.8V99.2C27.8,94.9,26.5,91.2,23.8,88.1z"
							/>
							<path
								className="st0"
								d="M265.3,174c-5.6,5-12.6,7.4-21.1,7.4c-12.2,0-21.3-4.8-27.4-14.4c-6.3-9.3-9.5-22.6-9.5-39.9c0-17.9,3.2-31.6,9.5-40.9c6.6-9.3,16-13.9,28.2-13.9c8.7,0,15.7,2.3,21.1,7c2.6,3.1,4.9,6.7,6.8,10.7c2.6,6.5,7.1,9.8,13.5,9.8h17.1c-1.3-17.9-6.9-31.9-16.7-41.8c-10.3-10.2-24.2-15.3-41.7-15.3c-21.5,0-37.9,7.3-49.3,21.8C184.6,78.3,179,99.2,179,127.1c0,27.2,5.4,47.8,16.3,61.8c10.9,14.6,26.6,21.8,47.3,21.8c17.7,0,32.1-5.1,42.9-15.3c10.6-10.5,16.6-25.1,17.9-43.7H276C273.8,161.9,270.3,169.4,265.3,174z"
							/>
							<path
								className="st0"
								d="M420.7,101.6c-5-8.1-11.3-13.9-18.7-17.7c-7.9-3.7-16.3-4.3-25-1.9c-8.8,2.5-15.5,8.4-20.3,17.7V63c0-4.3-1.3-8.1-4-11.1c-2.6-3.1-5.8-4.6-9.5-4.6h-13.5V207h27v-63.7c0-10.8,2-19.3,6-25.5c4-6.2,9.7-9.3,17.1-9.3c6.9,0,12.3,3.3,16.3,9.8c2.4,4,3.9,8,4.6,11.8c0.7,3.9,1,8.1,1,12.8V207h26.6v-72C428.2,120.8,425.7,109.6,420.7,101.6z"
							/>
							<path
								className="st0"
								d="M528.8,89.5c-7.4-5.9-18.5-8.8-33.4-8.8c-13.3,0-23.4,3.6-30.6,10.7c-6.3,6.2-10.1,14.1-11.1,23.7h26.6c1.3-3.4,3.4-5.7,6.4-7c2.9-1.2,6.2-1.9,9.9-1.9c3.4,0,7.2,0.7,11.3,2.1c4.1,1.4,6.2,4.4,6.2,9.1c0,6.2-5.8,10.2-17.5,12.1c-2.4,0.3-4.5,0.7-6.3,1.2c-1.9,0.5-3.4,0.7-4.8,0.7c-10.1,1.9-18.3,5.6-24.8,11.2c-6.5,5.6-9.7,14.9-9.7,27.9c0,13.9,3.6,23.9,10.7,30c7.2,6,15.5,9.1,25,9.1c4.8,0,10.2-0.4,16.5-1.2c6.2-0.8,12.1-2.9,17.7-6.3c5.3-3.1,9.9-8.1,13.7-15.1c3.8-7,5.8-16.6,5.8-29v-42.3C540.4,104.3,536.5,95.7,528.8,89.5z M514.5,156.4c0,8.7-2.1,15.5-6.3,20.4c-4.3,5-10.1,7.4-17.5,7.4c-4.5,0-7.9-1.2-10.3-3.7c-2.4-2.8-3.6-6.5-3.6-11.1c0-3.4,0.9-6.8,2.8-10.2c2.1-2.5,5.6-4.5,10.3-6l9.1-2.3c6.6-1.9,11.8-3.9,15.5-6V156.4z"
							/>
							<path
								className="st0"
								d="M642.2,91.3c-9.8-7.1-20.5-10.7-32.2-10.7c-11.4,0.6-21.8,4.5-31.2,11.6c-9.4,7.1-14.1,21.2-14.1,42.3V207h27.8v-79c0-7.4,1.8-12.8,5.6-16.3c3.7-3.4,7.9-5.1,12.7-5.1c4.8,0,9.1,1.7,12.9,5.1c3.8,3.4,5.8,8.8,5.8,16.3v63.2c0,4.6,1.2,8.4,3.8,11.4c2.5,2.9,5.8,4.4,9.7,4.4h13.9v-72.5C656.8,112.9,651.9,98.5,642.2,91.3z"
							/>
							<path
								className="st0"
								d="M762.2,92.7c-10.9-8.1-22.7-12.1-35.4-12.1c-16.7,0-28.8,6-36.4,17.9c-7.6,11.9-11.3,27.5-11.3,46.7c0,16.4,2.9,29.7,8.5,39.7c5.7,10.1,12.5,17,20.5,20.7c7.9,3.7,16,4.5,24,2.3c8.1-2.2,14.5-7.6,19.3-16.2v7.9c-0.5,9.9-2.6,17.3-6.2,22.3c-3.6,5-7.6,8-11.9,9.1c-4.4,1.1-8.7,0.5-13.1-1.9c-4.4-2.3-7.6-5.6-9.8-10h-29c5.8,26.6,20.9,39.9,45.3,39.9c12.7,0,24.5-3.9,35.4-11.8c10.9-7.9,16.3-22.7,16.3-44.4v-65.5C778.5,115.7,773.1,100.8,762.2,92.7z M750.7,157.1c-1.1,7.3-2.8,12.6-5.2,16c-5,8.1-12.8,10.9-23.4,8.6c-10.6-2.3-15.9-14.2-15.9-35.5c0-9.9,1.6-18.7,4.8-26.5c3.2-7.7,9.3-11.6,18.3-11.6c6.6,0,11.7,2.8,15.1,8.4c3.4,5.6,5.6,11.9,6.6,19C751.8,142.6,751.7,149.8,750.7,157.1z"
							/>
							<path
								className="st0"
								d="M898.6,143.8c-14.2-11.9-23.2-29.7-23.2-49.6c0-2.1,0.1-4.2,0.3-6.3c-7.4-4.9-16.3-7.3-26.8-7.3c-15.1,0-26.9,5.7-35.4,17.2c-8.2,11.2-12.3,26.6-12.3,46.5c0,20.7,4.2,36.7,12.7,47.8c8.5,11.5,20.3,17.2,35.4,17.2c12.4,0,22.8-3.6,31-10.7c8.2-6.8,13.8-16.7,16.7-29.7h-19.9c-3.2,0-5.6,0.8-7.3,2.3c-1.7,1.6-2.7,2.8-3,3.7c-0.8,0.9-1.5,1.8-2.2,2.6c-0.7,0.8-1.4,1.3-2.2,1.6c-3.2,2.2-7,3.3-11.5,3.3c-6.9,0-12.1-2.5-15.5-7.4c-3.7-4.6-5.7-11.8-6-21.4h68.7c0.2-0.6,0.4-1.7,0.4-3.3v-5.1C898.6,144.7,898.6,144.3,898.6,143.8z M829.5,132.7c0.2-8.1,2.2-14.3,6-18.6c3.7-4.3,8.5-6.5,14.3-6.5c6.4,0,11.3,2.2,14.7,6.5c3.2,4,5,10.2,5.6,18.6H829.5z"
							/>
						</g>
						<path
							className="st0"
							d="M147.5,46.2c0,0,9.3,111.5-140.6,219.6C5.7,264.6,151,207.7,167.2,74.1C168.4,55.5,147.5,46.2,147.5,46.2z"
						/>
						<path
							className="st0"
							d="M76.6,46.2c0,0-27.9,291.6,454.3,189.4c0-1.2,5.8,1.2,5.8,1.2s-441.5,122-481-153.4C56.9,83.4,59.2,56.7,76.6,46.2z"
						/>
						<path
							className="st0"
							d="M941.8,35.8c-32.2,0-58.2,26.1-58.2,58.2c0,32.2,26.1,58.2,58.2,58.2S1000,126.2,1000,94C1000,61.8,973.9,35.8,941.8,35.8z M969,117.3v14.6h-59c0-7.7,1.8-14.4,5.5-20.3c3.4-5.4,8.4-10.4,15-15c0.5-0.3,1.2-0.8,2.2-1.3c1-0.5,2.1-1.2,3.3-2c5.2-3.4,9.3-6.5,12.2-9.3s4.3-5.9,4.3-9.1c0-3.8-1.1-6.8-3.3-8.8c-2.2-2.2-5.2-3.3-9.1-3.3c-4.3,0-7.6,1.3-10,4c-2.2,2.9-3.3,6.6-3.3,11.2v0.7h-8.6c-3.3,0-5.3-0.9-5.9-2.8c-0.6-1.8-0.7-3.9-0.4-6.1c1.1-5.2,3.4-9.8,6.9-13.6c5.2-5.1,12.6-7.6,22.2-7.6c8.9,0,15.9,2.3,21,6.9c5.1,4.9,7.7,11.3,7.7,19.1c0,5.9-1.4,10.7-4.1,14.6c-2.9,4.3-8.1,9-15.7,14.1c-2.7,1.9-6.1,4.1-10.1,6.7c-4.1,2.6-6.3,5-6.8,7.4H969z"
						/>
					</svg>
				</div>
				<div className="app-header-info">
					{userRole === 'admin' && (
						<>
							<Label size="small">
								{`Front-end : ${frontendVersion ?? 'non défini'}`}
							</Label>
							<Label size="small">
								{`Back-end : ${backendVersion ?? 'non défini'}`}
							</Label>
						</>
					)}
					{userRole === 'admin' && (
						<Label color="red" size="small">
							<Icon name="shield" />
							Mode administrateur
						</Label>
					)}
					{userRole === 'adminConsult' && (
						<Label color="blue" size="small">
							<Icon name="eye" />
							Mode consultation
						</Label>
					)}
					{denomination && <p className="collectivite-info">{denomination}</p>}
					<Button onClick={onLogout} icon="log-out" color="red">
						Déconnexion
					</Button>
					{onChangeClient && (
						<Button
							icon="exchange"
							color="blue"
							onClick={onChangeClient}
							title="Changer de code client"
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export default AppHeader;
